"use client"

import { useEffect, useState } from "react"

export interface ProyekLain {
  url: string
  name: string
  favicon: string
}

const URL_DAFTAR = "https://raw.githubusercontent.com/zassxd/database/refs/heads/main/json/link-project.json"
const KUNCI_CACHE = "proyekLainCache"
const TTL_CACHE_MS = 30 * 60 * 1000

let cacheMemori: ProyekLain[] | null = null
let permintaanBerjalan: Promise<ProyekLain[]> | null = null

function bacaCache(): ProyekLain[] | null {
  if (cacheMemori) return cacheMemori
  try {
    const mentah = sessionStorage.getItem(KUNCI_CACHE)
    if (!mentah) return null
    const { waktu, daftar } = JSON.parse(mentah) as { waktu: number; daftar: ProyekLain[] }
    if (!Array.isArray(daftar) || Date.now() - waktu > TTL_CACHE_MS) return null
    cacheMemori = daftar
    return daftar
  } catch {
    return null
  }
}

function simpanCache(daftar: ProyekLain[]) {
  cacheMemori = daftar
  try {
    sessionStorage.setItem(KUNCI_CACHE, JSON.stringify({ waktu: Date.now(), daftar }))
  } catch {}
}

async function ambilMetadata(link: string): Promise<ProyekLain> {
  try {
    const respons = await fetch(`/api/scrape-meta?url=${encodeURIComponent(link)}`)
    if (respons.ok) {
      const meta = await respons.json()
      return { url: link, name: meta.name, favicon: meta.favicon }
    }
  } catch {}
  const domain = new URL(link).hostname.replace("www.", "")
  return { url: link, name: domain, favicon: `${new URL(link).origin}/favicon.png` }
}

function muatSemua(): Promise<ProyekLain[]> {
  if (permintaanBerjalan) return permintaanBerjalan
  permintaanBerjalan = fetch(URL_DAFTAR)
    .then((respons) => respons.json())
    .then((tautan: unknown) => (Array.isArray(tautan) ? Promise.all(tautan.filter((item): item is string => typeof item === "string").map(ambilMetadata)) : []))
    .then((daftar) => {
      simpanCache(daftar)
      return daftar
    })
    .finally(() => {
      permintaanBerjalan = null
    })
  return permintaanBerjalan
}

export function useProyekLain() {
  const [projects, setProjects] = useState<ProyekLain[]>([])
  const [loadingProjects, setLoadingProjects] = useState(true)

  useEffect(() => {
    let batal = false
    const tersimpan = bacaCache()
    if (tersimpan) {
      setProjects(tersimpan)
      setLoadingProjects(false)
      return
    }

    muatSemua()
      .then((daftar) => {
        if (!batal) setProjects(daftar)
      })
      .catch(() => {})
      .finally(() => {
        if (!batal) setLoadingProjects(false)
      })

    return () => {
      batal = true
    }
  }, [])

  return { projects, loadingProjects }
}
